<template>
  <div class="h-100">
    <b-button
      v-show="(!id && step > 1) || (id && step === 5)"
      type="submit"
      class="myButton"
      @click="previousStep">
      {{ $t('common.Previous') }}
    </b-button>
    <b-button
      v-show="step === 1"
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Cancel') }}
    </b-button>
    <transition name="slide-fade-main"
                mode="out-in"
                appear>
      <CreateEditCategory
        v-if="step === 1"
        @next-step="nextStep" />
      <CreateEditSubCategory v-if="step === 2"
                             @next-step="nextStep" />
      <CreateEditGeneCombination
        v-if="step === 3"
        @next-step="nextStep" />
      <CreateEditGenotypeCombinations
        v-if="step === 4 && ready"
        @next-step="nextStep" />
      <div v-else-if="step === 4 && !ready"
           class="dp04 text-center">
        <span>
          {{ $t('DataTable.Loading') }}...
        </span>
        <b-spinner
          class="ml-3"
          variant="primary"
          label="Spinning" />
      </div>

      <CreateEditTemplateStep v-if="step === 5" />
    </transition>
  </div>
</template>

<script>
import CreateEditCategory from '@components/admin/templates/create/CreateEditCategory';
import CreateEditSubCategory from '@components/admin/templates/create/CreateEditSubCategory';
import CreateEditGeneCombination from '@components/admin/templates/create/CreateEditGeneCombination';
import CreateEditGenotypeCombinations from '@components/admin/templates/create/CreateEditGenotypeCombinations';
import CreateEditTemplateStep from '@components/admin/templates/create/CreateEditTemplateStep';
import { mapMutations, mapGetters, mapActions } from 'vuex';

export default {
  name: 'CreateEditTemplate',
  components: {
    CreateEditCategory,
    CreateEditSubCategory,
    CreateEditGeneCombination,
    CreateEditGenotypeCombinations,
    CreateEditTemplateStep
  },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    step() {
      return this.getStepNumber();
    },
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapMutations({
      nextStep: 'createTemplate/nextStep',
      previousStep: 'createTemplate/previousStep',
      setStepNumber: 'createTemplate/setStepNumber'
    }),
    ...mapGetters({ getStepNumber: 'createTemplate/getStepNumber' }),
    ...mapActions({ resetContext: 'createTemplate/resetContext', fetchForEdit: 'createTemplate/fetchTemplateById' })
  },
  created() {
    this.resetContext();
    if (this.id) {
      this.setStepNumber(4);
      this.fetchForEdit(this.id).then(() => { this.ready = true; });
    } else {
      this.ready = true;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
